
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "criteria_of_CH",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/criteria_of_CH.vue